import React from 'react'
import { Link } from '../../../ui'
import queryString from 'query-string'
import { useStore } from '../../../StateProvider'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import cn from 'classnames'
import styles from './style.css'

/**
 * @param {{ className: ?string, text: ?string, , loginURL: ?string}} props
 */
const LoginLink = ({ className, text, isHeader = false, loginURL: customLoginURL }) => {
  const { t, i18n: { language } } = useTranslation()
  const location = useLocation()
  const [{ whitelabel }] = useStore()
  const { loginURL } = whitelabel

  const { iframe = '' } = queryString.parse(location.search)
  const shouldHideLoginButton = iframe === 'true' || !loginURL

  if (shouldHideLoginButton) {
    return null
  }

  const url = new URL(customLoginURL || loginURL)
  url.searchParams.append('lang', language)

  return (
    <div className={cn(styles.loginLinkBlock, { [styles.isHeader]: isHeader })}>
      <Link href={url} className={className}>
        {t(text)}
      </Link>
    </div>
  )
}

LoginLink.defaultProps = {
  text: 'loginLink.login',
  className: styles.loginLink
}

export default LoginLink
